var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_content"},[_c('div',{staticClass:"empty_content--content"},[_c('h4',{staticClass:"empty_content--heading"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_c('p',{staticClass:"empty_content--message"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }